import { render, staticRenderFns } from "./DefiDeposit.vue?vue&type=template&id=544ce94a&"
import script from "./DefiDeposit.vue?vue&type=script&lang=js&"
export * from "./DefiDeposit.vue?vue&type=script&lang=js&"
import style0 from "./DefiDeposit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports